<template>
  <div v-if="chipsData.length" class="mb-8px flex flex-wrap justify-start gap-8px">
    <div v-for="(item, index) in chipsData" :key="index">
      <TagChip :chip-data="item" @remove="tagStore.removeTag(item.key)" />
    </div>
    <p
      v-if="chipsData.length >= 2"
      class="text-blue-default mx-16px flex cursor-pointer items-center justify-center content-12-h16-r hover:underline"
      @click="tagStore.removeAllTags()"
    >
      {{ $t('btn.clear') }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { type ChipData } from '@/components/TagChip.type'
import TagChip from '@/components/TagChip.vue'
import { useTagStore } from '@/store/tagStore'

defineProps<{
  chipsData: ChipData[]
}>()

const tagStore = useTagStore()
</script>
